<template>
  <layout-content>
    <create-form />
  </layout-content>
</template>
<script>
  import CreateForm from '@autoinformer/components/campaigns-create-form';
  export default {
    components: { CreateForm }
  };
</script>
